import { render, staticRenderFns } from "./BillingRegister.vue?vue&type=template&id=13b09ce2&scoped=true"
import script from "./BillingRegister.vue?vue&type=script&lang=js"
export * from "./BillingRegister.vue?vue&type=script&lang=js"
import style0 from "./BillingRegister.vue?vue&type=style&index=0&id=13b09ce2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b09ce2",
  null
  
)

export default component.exports